export { default as AssetReportWrapper } from './AssetReportWrapper';
